// extracted by mini-css-extract-plugin
var _1 = "SidebarSection-module__animateUploadProgressBarWidth--oB84V";
var _2 = "SidebarSection-module__animatedBackground--nlR9p";
var _3 = "SidebarSection-module__container--Fjhl0";
var _4 = "SidebarSection-module__isPublicVariant--RlDsK";
var _5 = "SidebarSection-module__title--dqrwJ";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "isPublicVariant", _5 as "title" }
